module.exports = __webpack_public_path__ + "static/img/ranqizaoa950cf7.png";